// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';
import { getCookie } from 'utils/cookies';


const deleteUser = async (password, contextConfiguration) => {
	const token = getCookie('authToken');
	return axios.delete(
		'/user',
		{
			...commonConfiguration,
			...contextConfiguration,
			data: { password },
			headers: {
				Authorization: token ? `Token ${token}` : undefined,
				'X-Requested-With': 'XMLHttpRequest',
			}
		}
	).catch((error) => {
		onRequestError(error);
		return error && error.response;
	});
};

export default deleteUser;
